import React, { useRef } from 'react';
import emailjs from 'emailjs-com';
import { Col, Row, Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';

const ContactForm = () => {

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_uzwxvwk', 'template_cqsj4rq', form.current, 'user_BxTcois8AjvmR01Ga5oMW')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
    };

    return (
        <div className="mx-auto my-5 border border-1 rounded border-secondary p-5" style={{ maxWidth: '80vw', maxHeight: '50vh' }}>
            <Form ref={form} onSubmit={sendEmail}>
                <Row className="mb-3 ">


                    <Form.Group as={Col} controlId="formGridName">
                        <Form.Control type="text" placeholder="name" name="name" />
                    </Form.Group>

                    <Form.Group as={Col} controlId="formGridEmail">
                        <Form.Control type="email" placeholder="email" name="email" />
                    </Form.Group>
                </Row>

                <Form.Group className="mb-3" controlId="subject">

                    <Form.Control placeholder="subject" name="subject" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">

                    <Form.Control as="textarea" rows={3} placeholder="message" name="message" />
                </Form.Group>

                <Button variant="primary px-4 py-2 " type="submit">
                    Submit
                </Button>
            </Form>







        </div>
    );
};

export default ContactForm;